import { render, staticRenderFns } from "./backCollectionTask.vue?vue&type=template&id=4769b745&scoped=true"
import script from "./backCollectionTask.vue?vue&type=script&lang=js"
export * from "./backCollectionTask.vue?vue&type=script&lang=js"
import style0 from "./backCollectionTask.vue?vue&type=style&index=0&id=4769b745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4769b745",
  null
  
)

export default component.exports